export default {
    methods:{
        getNameFullnameFromFieldKey_CBC(_key){
            const tmp = this.mapField_Fullname.find(dat=>dat.field_name == _key)
            return tmp ? {
                                  "nick_name" : tmp.nick_name,
                                  "full_name" : tmp.full_name
                          } 
                       : 
                          {
                                  "nick_name" : "",
                                  "full_name" : ""
                          }
        }
    }

}